// components/Accountability/index.js
import CallFromPartner from "./Partner/CallFromPartner";

export const accountabilityRegistry = {
  call_from_partner: CallFromPartner,
  // future types: daily_checkin, weekly_review, goal_alignment, etc.
};
